import { Product } from '../../../lib/product';

export class ExternalCardRechargeModel {
  product: Product;
  cardNumber: string;
  cardBalance: number;
  ean13: string;
  personalNumber: string;
}
